import React from "react";
import { KIT_OFFERS } from "../config";

// Controlled offer selector — both options are simple one-time purchases.
export const OfferSelector = ({ selectedId, onSelect }) => (
  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }} data-testid="kit-offer-selector">
    {KIT_OFFERS.map((offer) => {
      const active = selectedId === offer.id;
      return (
        <button
          key={offer.id}
          data-testid={`offer-${offer.id}`}
          onClick={() => onSelect(offer.id)}
          className="btn"
          style={{
            position: "relative", textAlign: "left", padding: "20px 16px 18px",
            background: "var(--surface)", borderRadius: 4,
            border: active ? "2px solid var(--accent)" : "1px solid var(--border)",
            display: "flex", flexDirection: "column", gap: 6, minHeight: 118,
            color: "var(--text)", cursor: "pointer",
          }}
        >
          {offer.badge && (
            <span style={{ position: "absolute", top: -11, left: 14, background: "var(--accent)", color: "var(--on-accent)", fontSize: 10, fontWeight: 700, letterSpacing: "0.08em", padding: "3px 8px", borderRadius: 4, fontFamily: "var(--display)", textTransform: "uppercase" }}>{offer.badge}</span>
          )}
          <span className="display" style={{ fontSize: 13, letterSpacing: "0.04em", textTransform: "uppercase", color: active ? "var(--text)" : "var(--text-muted)", fontWeight: 500 }}>{offer.label}</span>
          <span style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
            <span className="price" style={{ fontSize: 26 }}>{offer.price} €</span>
            {offer.strike && <span className="price-strike" style={{ fontSize: 14 }}>{offer.strike} €</span>}
          </span>
          {offer.note && <span style={{ fontSize: 12, color: "var(--text-muted)", lineHeight: 1.4 }}>{offer.note}</span>}
          {offer.shipping_note && <span data-testid={`offer-shipping-${offer.id}`} style={{ fontSize: 12, color: "var(--accent)", lineHeight: 1.4, fontWeight: 600 }}>{offer.shipping_note}</span>}
        </button>
      );
    })}
  </div>
);
